import { useNewCode } from '@calendly/feature-check-react';
import { I18n } from '@calendly/i18n';
import { Avatar } from '@calendly/ui/components/avatar';
import { BareButton } from '@calendly/ui/components/bare-button';
import { IconButton } from '@calendly/ui/components/icon-button';
import { ArrowChevronDownMiniIcon, ArrowChevronUpMiniIcon, EditPencilIcon } from '@calendly/ui/components/icons';
import { BodyText } from '@calendly/ui/components/typography';
import { colorTextSecondary } from '@calendly/ui/theme';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { RemoteContactCard } from 'features/crm';
import { getInitials } from 'shared/utils';
import CancelledIcon from './cancel.svg';
import ConfirmedIcon from './confirmed.svg';
import { InviteeActions } from './invitee_actions';
import { NoShowButton } from './no_show_button';
import { getPaymentInfo } from './payment_utils';
import RescheduledIcon from './reschedule.svg';
import { AvatarContainer, AvatarIcon, AvatarDropdownContainer, Heading, Name } from './styles';
import { FullStoryExclude, FullStoryMask } from '../../../../../../shared/fullstory_privacy';
const minimalButtonCss = "m171g3zj";
const MinimalButton = forwardRef((props, ref) => <BareButton ref={ref} {...props} className={classNames(minimalButtonCss, props.className)} />);
const noShowButtonContainerCss = "nfronh9";
const NoShowButtonContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(noShowButtonContainerCss, props.className)} />;
});
const emailButtonContainerCss = "e1knd1c3";
const EmailButtonContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(emailButtonContainerCss, props.className)} />;
});
const displayNameCss = "dt5aw8u";
const DisplayName = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(displayNameCss, props.className)} />;
});
export const AvatarDropdown = ({
  displayName,
  isCancelled,
  isRescheduled,
  isConfirmed,
  isGuest,
  contact,
  onHeadingClick,
  openEditEmailModal,
  nameButtonRef,
  isGroup,
  turnOnNoShowClicked,
  canEditEmail,
  canMarkNoShow,
  event,
  invitee,
  toggle,
  isOpen,
  canReschedule = false,
  canCancel = false,
  canBlock = false,
  canUnblock = false,
  shouldShowMenu = false,
  isLegacy = false
}) => {
  const {
    charge
  } = invitee;
  const hasCharge = charge && charge.captured;
  const showCharge = isGroup && !isLegacy && hasCharge;
  const isCRMContactCardEnabled = useNewCode('crm_contactcard_feature')?.enabled;
  const paymentInfo = getPaymentInfo(charge, showCharge);
  return <>
      <AvatarContainer>
        <FullStoryExclude>
          <Avatar letter={getInitials(displayName)} alt={displayName} aria-label={displayName} size="small" tooltip={displayName} />
          {isCancelled && <AvatarIcon src={CancelledIcon} />}
          {isRescheduled && <AvatarIcon src={RescheduledIcon} />}
          {isConfirmed && <AvatarIcon src={ConfirmedIcon} />}
        </FullStoryExclude>
      </AvatarContainer>
      <Heading isGuest={isGuest} isContact={Boolean(contact)}>
        {isCRMContactCardEnabled && contact ? <AvatarDropdownContainer>
            <RemoteContactCard contact={contact} position="below">
              <Name strike={isCancelled || isRescheduled} onClick={onHeadingClick} ref={nameButtonRef}>
                <DisplayName><FullStoryMask>{displayName}</FullStoryMask></DisplayName>
              </Name>
            </RemoteContactCard>
          </AvatarDropdownContainer> : <Name strike={isCancelled || isRescheduled} onClick={onHeadingClick} ref={nameButtonRef}>
            <DisplayName><FullStoryMask>{displayName}</FullStoryMask></DisplayName>
          </Name>}
        {showCharge && <BodyText size="small" color="muted">
            <FullStoryMask>{paymentInfo}</FullStoryMask>
          </BodyText>}
        {isGuest && <BodyText size="x-small" color={colorTextSecondary}>{I18n.t('publisher.meetings.invitees.guest_label')}</BodyText>}
        {!isGroup && canEditEmail && !shouldShowMenu && <EmailButtonContainer>
            <MinimalButton onClick={openEditEmailModal}>
              <EditPencilIcon />
              <BodyText size="x-small">
                {I18n.t('publisher.meetings.invitees.edit_invitee_email')}
              </BodyText>
            </MinimalButton>
          </EmailButtonContainer>}
      </Heading>
      {canMarkNoShow && <NoShowButtonContainer>
          <NoShowButton event={event} invitee={invitee} onMarkAsNoShow={turnOnNoShowClicked} />
        </NoShowButtonContainer>}
      {shouldShowMenu && <InviteeActions event={event} invitee={invitee} canReschedule={canReschedule} canCancel={canCancel} canBlock={canBlock} canUnblock={canUnblock} openEditEmailModal={openEditEmailModal} canEditEmail={canEditEmail} />}
      {isGroup && isLegacy && <IconButton size="small" onClick={toggle} aria-label={isOpen ? I18n.t('publisher.meetings.invitees.hide_details') : I18n.t('publisher.meetings.invitees.show_details')}>
          {isOpen ? <ArrowChevronUpMiniIcon /> : <ArrowChevronDownMiniIcon />}
        </IconButton>}
    </>;
};

require("./avatar_dropdown.wyw-in-js.css!=!../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./avatar_dropdown.js");